import {
  Component,
  OnInit,
  ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import {
  defaults as defaultInteractions,
  Draw,
} from 'ol/interaction';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { Polygon } from 'ol/geom';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { Fill, Stroke, Style } from 'ol/style';
import { BingMaps, XYZ } from 'ol/source';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

declare let $: any;

@Component({

  selector: 'app-supply-locations',

  templateUrl: './supply-locations.component.html',

  styleUrls: ['./supply-locations.component.css']

})

export class SupplyLocationsComponent implements OnInit {

  map: any = {};

  mapSatelait: boolean = false;

  GeoFenceData: any;

  GeoFenceId: number = -1;

  source: any;

  vector: any;

  draw: any;

  polygonEvent: any;

  polyganName = new FormControl();

  tooltipData: any;

  layers: any = [];

  location: any;

  list_Geofence: any = [];

  bDonotShowMap: boolean = false;

  editMode: boolean = false;

  selectedItem: any;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private otherService: OtherService,

    private mapService: MapService,

    private gurdService: GurdServiceService,

    private router: Router,


  ) { }

  ngOnInit(): void {

    this.getRadyab();

    $('#savePolygan').on('hidden.bs.modal', () => {

      this.source.removeFeature(this.polygonEvent);

      this.polyganName.setValue('');

    });

  }

  ngAfterViewInit(): void {

    setTimeout(() => {

      this.newOpenMap();

    }, 100);

    setTimeout(() => {

      //Handel Add Polygon

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        this.map.removeInteraction(this.draw);

        $('#savePolygan').modal('show');

      });

      this.map.on('pointermove', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        //Handel cursor
        var pixel = this.map.getEventPixel(e.originalEvent);
        var hit = this.map.hasFeatureAtPixel(pixel);
        this.map.getViewport().style.cursor = hit ? 'pointer' : '';
      });

      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );

      });

      this.map.getView().on('propertychange', (e: any) => {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
        this.tooltipData = null;
      });
    }, 500);
  }

  async getRadyab() {

    this.otherService.Showspinner();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      bShower: 1

    }

    let res = JSON.parse((await axios.post(`Radyab_GeoFence`, model)).data.toString());

    this.otherService.nonespinner()

    this.list_Geofence = res;

  }

  GeoFence(event: any) {

    if (event != -1) {

      this.selectedItem = this.list_Geofence.find((el: any) => el.iGeoFence == event);

      if (this.selectedItem != undefined) {

        this.editMode = true;

        const selectedItem = this.selectedItem?.lstPoints;

        this.mapService.removeLayerByName('polygon', this.map);

        var ring = [];

        if (selectedItem.length != 0) {

          var loc = selectedItem;

          for (let index = 0; index < loc.length; index++) {

            ring.push([loc[index].fLon, loc[index].fLat]);
          }

          var polygon = new Polygon([ring]);

          polygon.transform('EPSG:4326', 'EPSG:3857');

          var feature = new Feature(polygon);

          var vectorSource = new VectorSource();

          vectorSource.addFeature(feature);

          var vectorLayer = new VectorLayer({

            source: vectorSource,

            name: 'polygon',

            style: new Style({

              stroke: new Stroke({

                color: 'red',

                width: 4,

                lineDash: [10, 20, 10, 20]

              }),

              fill: new Fill({

                color: 'rgba(0, 0, 255, 0)'

              })

            }),

          } as any);

          this.map.addLayer(vectorLayer);

          this.fitMap(selectedItem);

        }

      }

      else this.mapService.removeLayerByName('polygon', this.map);

    }

    else this.editMode = false;

  }

  addInteraction() {

    this.mapService.removeLayerByName('polygon', this.map);

    this.selectedItem = undefined;

    this.editMode = false;

    const value = 'Polygon';

    this.draw = new Draw({

      source: this.source,

      type: value,

    });

    this.map.addInteraction(this.draw);

  }

  fitMap(data?: any) {

    if (data == null) return;

    this.mapService.fitMap(data, this.map);

    if (data.length == 1) this.map.getView().setZoom(17);

  }

  newOpenMap() {
    this.source = new VectorSource({ wrapX: false });
    this.vector = new VectorLayer({
      source: this.source,
    });

    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' // 

          }),

        })

      );

    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

              imagerySet: styles[i],

            }),

          }),

        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


    }

    this.map = new Map({

      controls: defaultControls().extend([new FullScreen()]),

      layers: this.layers,

      target: 'test2',

      view: new View({

        center: olProj.fromLonLat([51.3833554, 35.6770113]),

        zoom: 13,

      }),

    });

  }

  changeTail() {

    if (this.mapSatelait == false) {

      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }

    else {

      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);

    }

    this.mapSatelait = !this.mapSatelait;
  }

  savePolygon = async () => {

    if (this.polyganName.value == null || this.polyganName.value == '') return this.notifyService.showError('لطفا نام محدوده را وارد کنید')

    var point = [] as any;

    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {

      var data = this.mapService.transformCoordinates(item);

      point.push({ fLat: data[1], fLon: data[0] });

    });

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strTitle: this.polyganName.value,

      lstPoints: point,

      bShower: 1

    };

    this.source.removeFeature(this.polygonEvent);

    $('#savePolygan').modal('hide');

    this.otherService.Showspinner()

    const resp = await axios.post(`Radyab_InsertGeoFence`, model);

    this.otherService.nonespinner()

    this.polyganName.setValue('');

    let respJson = JSON.parse(resp.data);

    if (respJson.iResult == 0) this.notifyService.showError(respJson.strError);

    if (respJson.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      return this.router.navigate(['login']);

    }

    if (respJson.iResult == 1) {

      this.notifyService.showSuccess('با موفقیت ثبت شد');

      this.getRadyab()

    };


  };

  deleteArea = () => {

    if (this.selectedItem != undefined) {

      $.confirm({

        title: `آیا از حذف این محدوده اطمینان دارید؟`,

        content: '',

        type: 'red',

        buttons: {

          ok: {

            text: 'تایید',

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              var model = {

                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

                iGeoFence: this.selectedItem.iGeoFence,

                bShower: 1

              };

              const resp = await axios.post(`Radyab_DeleteGeoFence`, model);

              var data = JSON.parse(resp.data);

              if (data.ISSessionExpired == true) {

                this.notifyService.showError('لطفا وارد سیستم شوید');

                this.otherService.removeLocalStorage();

                this.router.navigate(['login']);

                return;

              }

              if (data.iResult == 1) {

                this.mapService.removeLayerByName('polygon', this.map);

                this.notifyService.showSuccess('با موفقیت حذف شد');

                const index = this.list_Geofence.indexOf(this.selectedItem)

                if (index != -1) this.list_Geofence.splice(index, 1);

                this.selectedItem = undefined;


              }

              else this.notifyService.showError(resp.data.strError);
            },
          },

          cancel: {

            text: 'لغو',

          },

        },

      });
    }

    else this.notifyService.showWarning('لطفا محدوده ای را انتخاب کنید', 'هشدار');

  };

  editArea() {

    this.polyganName.setValue(this.selectedItem.strTitle)

    $('#savePolygan').modal('show');

  }

  submitEditedTitle() {

    if (this.selectedItem.strTitle.trim() == this.polyganName.value.trim()) return this.notifyService.showError('نام جدید با نام قبلی یکسان است');

    else {

      const index = this.list_Geofence.indexOf(this.selectedItem);

      this.selectedItem.strTitle = this.polyganName.value;

      this.selectedItem.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

      this.selectedItem.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this.otherService.Showspinner()

              let res = JSON.parse((await axios.post(`Radyab_EditGeoFence`, this.selectedItem)).data.toString());

              this.otherService.nonespinner()

              if (index != -1) this.list_Geofence[index] = res;

              this.notifyService.showSuccess('با موفقیت ویرایش شد');

              $('#savePolygan').modal('hide');

              this.source.removeFeature(this.polygonEvent);

              this.polyganName.setValue('');

              this.mapService.removeLayerByName('polygon', this.map);

              this.editMode = false;

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

}
